<ng-template [ngIf]="ctxBodyFascicolo.fascicolo.capofila || ctxBodyFascicolo.fascicolo.riunito">
  <div class="row container_fieldset">
    <div class="col-sm-12">
      <fieldset class="form-group">
        <legend>Riunione dei giudizi</legend>
        <ng-template [ngIf]="ctxBodyFascicolo.fascicolo.capofila">
          <div labelTextInput class="col-sm-4 bloccodati"
               [typeLabel]="'text'" [labelInput]="'Capofila'"
               [valueInput]="ctxBodyFascicolo.fascicolo.capofila ? 'Si' : 'No'"></div>
        </ng-template>
        <ng-template [ngIf]="ctxBodyFascicolo.fascicolo.riunito">
          <div labelTextInput class="col-sm-4 bloccodati"
               [typeLabel]="'text'" [labelInput]="'Riunito'"
               [valueInput]="ctxBodyFascicolo.fascicolo.riunito ? 'Si' : 'No'"></div>
        </ng-template>
        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
             [labelInput]="'Data riunione'"
             [valueInput]="ctxBodyFascicolo.fascicolo.dataRiunioneGiudizio"></div>
        <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
             [labelInput]="'Motivo riunione'"
             [valueInput]="ctxBodyFascicolo.fascicolo.motivoRiunioneGiudizio"></div>
      </fieldset>
    </div>
  </div>
</ng-template>
<!-- <div class="row container_fieldset">
  <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Dati giudiziari</legend>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Numero/Anno ruolo'"
           [valueInput]="(ctxBodyFascicolo.fascicolo.numeroRuolo ? ctxBodyFascicolo.fascicolo.numeroRuolo : '')  + ((ctxBodyFascicolo.fascicolo.annoRuolo && ctxBodyFascicolo.fascicolo.numeroRuolo) ? '/' : '') + (ctxBodyFascicolo.fascicolo.annoRuolo ? ctxBodyFascicolo.fascicolo.annoRuolo : '')"></div>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Sezione'"
           [valueInput]="ctxBodyFascicolo.fascicolo.sezione"></div>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Giudice'"
           [valueInput]="ctxBodyFascicolo.fascicolo.giudice"></div>
      <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Processo telematico'"
           [valueInput]="ctxBodyFascicolo.fascicolo.flagProcessoTelematico ? 'Si' : 'No'"></div>
    </fieldset>
  </div>
</div> -->
<div class="row container_fieldset">
  <div class="col-sm-12">
    <fieldset class="form-group">
      <legend>Decreto ingiuntivo</legend>
      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
           [labelInput]="'N&deg; decreto ingiuntivo'"
           [valueInput]="ctxBodyFascicolo.fascicolo.numDecretoIngiuntivoRiferimento"></div>
      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
           [labelInput]="'Valore'"
           [valueInput]="ctxBodyFascicolo.fascicolo.valoreDecretoIngiuntivoRiferimento"></div>
      <div labelTextInput class="col-sm-4 bloccodati"
           [typeLabel]="'boolean'"
           [labelInput]="'Titolo esecutivo contestuale'"
           [valueInput]="ctxBodyFascicolo.fascicolo.titoloContestualeAlPrecetto"></div>
    </fieldset>
  </div>
</div>

<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
